
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AnchorHeroSection from './components/AnchorHeroSection';
import AnchorBenefitsSection from './components/AnchorBenefitsSection';
import AnchorRequirementsSection from './components/AnchorRequirementsSection';
import AnchorSuccessSection from './components/AnchorSuccessSection';
import AnchorApplicationSection from './components/AnchorApplicationSection';
import { updateSEO, addJSONLD } from '../../utils/seo';

export default function AnchorCooperation() {
  useEffect(() => {
    // Update SEO
    updateSEO({
      title: '主播合作 - 南滇古茶达人带货合作平台',
      description: '南滇古茶主播合作平台，为优秀主播提供高品质普洱茶货源、专业培训支持和丰厚佣金分成。立即加入我们的带货达人计划！',
      keywords: '主播合作,带货达人,普洱茶带货,直播卖茶,主播招募,佣金分成',
      type: 'website',
      url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/anchor-cooperation`
    });

    // Add JSON-LD structured data
    addJSONLD({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "主播合作服务",
      "description": "为主播提供普洱茶带货合作机会",
      "provider": {
        "@type": "Organization",
        "name": "南滇古茶"
      },
      "serviceType": "Influencer Marketing",
      "areaServed": "CN",
      "offers": {
        "@type": "Offer",
        "name": "主播合作计划",
        "description": "提供高品质货源、专业培训和佣金分成"
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "首页",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
          },
          {
            "@type": "ListItem",
            "position": 2, 
            "name": "主播合作",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/anchor-cooperation`
          }
        ]
      }
    });
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <AnchorHeroSection />
        <AnchorBenefitsSection />
        <AnchorRequirementsSection />
        <AnchorSuccessSection />
        <AnchorApplicationSection />
      </main>
      <Footer />
    </div>
  );
}
